export default "__VITE_ASSET__BJ5ZBXtV__"